import "./CommercialAccounts.module.css";
import Header from "@/reusable_sections/Header";
import Commercial from "./sections/Commercial";
import Wholesale from "./sections/Wholesale";
import Contact from "./sections/Contact";
import MinimumOrderInfo from "./sections/MinimumOrderInfo";
import NetTerms from "./sections/NetTerms";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function CommercialAccountsPage() {
  return <div>
      <Header />
      <Commercial />
      <Wholesale />
      <Contact />
      <MinimumOrderInfo />
      <NetTerms />
      <Faq />
      <Footer />
    </div>;
}